<ng-container [ngSwitch]="buttonPurpose">
    <ng-container *ngSwitchCase="'ROUTER_LINK'">
        <button [tabIndex]="tabIndex" [ngClass]="computedClassList" [hidden]="hidden" [disabled]="disabled || loading" [title]="titleText ? titleText : text" [routerLink]="routerLink" [queryParams]="queryParams" (click)="onButtonClick($event)">
            <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
        </button>
    </ng-container>

    <ng-container *ngSwitchCase="'MENU_TRIGGER'">
        <button [tabIndex]="tabIndex" [ngClass]="computedClassList" [hidden]="hidden" [disabled]="disabled || loading" [title]="titleText ? titleText : text" (click)="onButtonClick($event)" type="button" [matMenuTriggerFor]="matMenu" #unNamedMatMenuTrigger="matMenuTrigger">
            <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
        </button>
    </ng-container>

    <ng-container *ngSwitchDefault>
        <button [tabIndex]="tabIndex" [ngClass]="computedClassList" [hidden]="hidden" [disabled]="disabled || loading" [title]="titleText ? titleText : text" (click)="onButtonClick($event)" type="button" [matMenuTriggerFor]="matMenu">
            <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
        </button>
    </ng-container>
</ng-container>

<ng-template #buttonContent>
    <span [hidden]="hideRipple" class="mdc-button__ripple"></span>
    <span class="mdc-button__focus-ring"></span>

    <span class="mdc-button__label" [ngClass]="labelClassList">
        <!-- Prefix Icon/Image -->
        <ng-container *ngIf="prefixIcon || prefixImgSrc || prefixSvgIcon">
            <span *ngIf="prefixIconType === 'material'" [class]="prefixIconClasses" [textContent]="prefixIcon"></span>
            <img *ngIf="prefixIconType === 'image'" [src]="prefixImgSrc" [alt]="prefixImgAlt" [class]="perfixImgClasses" />
            <mat-icon *ngIf="prefixIconType === 'svg'" [svgIcon]="prefixSvgIcon" class="mdc-button__icon"></mat-icon>
        </ng-container>

        <!-- Loading Spinner -->
        <mat-spinner *ngIf="loading" [diameter]="24" class="button-spinner"></mat-spinner>

        <!-- Button Text -->
        <span class="button-text" [ngClass]="textClassList" *ngIf="text" [textContent]="displayText"></span>

        <!-- Button Description -->
        <span class="button-description" *ngIf="description" [textContent]="displayDescription"></span>

        <!-- Suffix Icon/Image -->
        <ng-container *ngIf="suffixIcon || suffixImgSrc || suffixSvgIcon">
            <span *ngIf="suffixIconType === 'material'" [class]="suffixIconClasses" [textContent]="suffixIcon"></span>
            <img *ngIf="suffixIconType === 'image'" [src]="suffixImgSrc" [alt]="suffixImgAlt" [class]="suffixImgClasses" />
            <mat-icon *ngIf="suffixIconType === 'svg'" [svgIcon]="suffixSvgIcon" class="mdc-button__icon"></mat-icon>
        </ng-container>
    </span>
    <ng-content></ng-content>
</ng-template>
